import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { Panel } from "~/components/v2/components/shared/panel/Panel";
import { PanelContent } from "~/components/v2/components/shared/panel/PanelContent";
import { useBoardSidebarStore } from "~/components/v2/store/features/board/useBoardSidebar";
export const BoardSidebar = /*#__PURE__*/ memo(()=>{
    const open = useBoardSidebarStore((store)=>store.open);
    const touched = useBoardSidebarStore((store)=>store.touched);
    const toggleOpen = useBoardSidebarStore((store)=>store.toggleOpen);
    const setOpen = useBoardSidebarStore((store)=>store.setOpen);
    useHotkeys("c", ()=>{
        toggleOpen();
    }, {
        preventDefault: true,
        scopes: [
            BOARD_SIDEBAR_HOTKEYS_SCOPE
        ]
    }, [
        toggleOpen
    ]);
    return /*#__PURE__*/ _jsx(Panel, {
        open: open,
        onOpenChange: setOpen,
        children: /*#__PURE__*/ _jsx(PanelContent, {
            className: "w-80 overflow-hidden rounded-12 bg-grey-1 animation-duration-300 animation-width-80 data-[animate=true]:motion-safe:radix-state-closed:animate-width-out data-[animate=true]:motion-safe:radix-state-open:animate-width-in",
            "data-animate": touched,
            children: "Board Sidebar"
        })
    });
});
BoardSidebar.displayName = "BoardSidebar";
export const BOARD_SIDEBAR_HOTKEYS_SCOPE = "board-sidebar";
